<div *ngIf="article" class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-content">
          <h1>
            {{ article?.title }}
          </h1>
         
        </div>
      </div>
    </div>
  </div>

  <div class="default-shape">
    <div class="shape-1"><img src="assets/img/shape/1.png" alt="image" /></div>
    <div class="shape-2 rotateme">
      <img src="assets/img/shape/2.png" alt="image" />
    </div>
    <div class="shape-3"><img src="assets/img/shape/3.svg" alt="image" /></div>
    <div class="shape-4"><img src="assets/img/shape/4.svg" alt="image" /></div>
    <div class="shape-5"><img src="assets/img/shape/5.png" alt="image" /></div>
  </div>
</div>

<section class="single-blog-area" *ngIf="article">

  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <div class="blog-details-desc">
          <div class="article-image">
            <h4 class="category-tag">
              {{ article?.category?.title }}
            </h4>
            <img
              src="{{ server + article?.image?.public_url }}"
              alt="{{ article?.title }}"
            />

            <div class="video-player" *ngIf="article.videoLink">
              <video autoplay="true" controls width="100%">
                  <source  [src]="article.videoLink" type="video/mp4">
              </video>
          </div>
          
          </div>

          <div class="article-content">
            <div class="entry-meta">
              <ul>
                <li>
                  <span>تم النشر بتاريخ:</span>
                  <h2 routerLink="/">
                    {{ article?.createdAt | date : 'fullDate' }}
                  </h2>
                </li>
              </ul>
            </div>

            <div
              *ngIf="article && article.content"
              class="isolated-content mt-4"
              [innerHTML]="article.content"
            ></div>
            <div class="review-section" dir="rtl">
              <h3 class="review-title">قم بتقييم المقال</h3>

              <div *ngIf="!showReviewForm" class="review-btn-container">
                <button (click)="showReviewForm = true" class="text-black btn btn-primary">
                  أدخل تعليقا عن المقال
                </button>
              </div>

              <div *ngIf="showReviewForm" class="review-form-container">
                <form (submit)="submitReview($event)" class="review-form">
                  <div class="form-group">
                    <label for="email">البريد الإلكتروني</label>
                    <input
                      type="email"
                      [(ngModel)]="review.email"
                      name="email"
                      required
                      class="form-control"
                      id="email"
                      placeholder="أدخل بريدك الإلكتروني"
                    />
                  </div>

                  <div class="form-group">
                    <label for="rating">التقييم</label>
                    <div class="star-rating">
                      <i
                        *ngFor="let star of stars; let i = index"
                        (click)="setRating(i + 1)"
                        [class.filled]="i < review.rating"
                        class="fa fa-star"
                      ></i>
                    </div>
                  </div>

                  <div class="form-actions">
                    <button type="submit" class="btn btn-submit">إرسال</button>
                    <button
                      type="button"
                      (click)="showReviewForm = false"
                      class="btn btn-cancel"
                    >
                      إلغاء
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="average-rating" (click)="toggleReviews()">
              <div class="rating-header">
                <span class="average-number">{{
                  averageRating | number : '1.1-1'
                }}</span>
                <div class="stars">
                  <mat-icon
                    *ngFor="let star of fullStars"
                    class="star-icon filled"
                    >star</mat-icon
                  >
                  <mat-icon *ngIf="halfStar" class="star-icon half"
                    >star_half</mat-icon
                  >
                  <mat-icon
                    *ngFor="let star of emptyStars"
                    class="star-icon empty"
                    >star_border</mat-icon
                  >
                </div>
              </div>

              <div class="reviews-info">
                <span class="reviews-count">{{ reviewsCount }} تقييم</span>
              </div>
            </div>

            <!--get reviews-->
            <section class="reviews-list">
              <h3 class="review-title">التقييمات</h3>

              <div *ngFor="let review of reviewsToShow" class="review-item">
                <div class="review-header">
                  <p>
                    <strong>{{ review.email }}</strong>
                  </p>
                </div>

                <div class="star-rating">
                  <i
                    *ngFor="
                      let star of starsArray(review.rating);
                      let i = index
                    "
                    class="fa fa-star"
                    [class.filled]="i < review.rating"
                  ></i>
                </div>
              </div>

              <!-- Afficher plus de commentaires -->
              <div *ngIf="reviews.length > 3" class="show-more-container">
                <button (click)="showMoreReviews()" class="btn btn-primary">
                  عرض المزيد
                </button>
              </div>
            </section>

            <div class="share-buttons">
              <button (click)="shareOnFacebook()" class="share-btn facebook">
                <i class="fab fa-facebook-f"></i> Facebook
              </button>
              <button (click)="shareOnTwitter()" class="share-btn x-twitter">
                <i class="fab fa-twitter"></i> X
              </button>
              <button (click)="shareOnLinkedIn()" class="share-btn linkedin">
                <i class="fab fa-linkedin-in"></i> LinkedIn
              </button>
              <button (click)="shareByEmail()" class="share-btn email">
                <i class="fas fa-envelope"></i> Email
              </button>

         
            </div>
          </div>

          <div class="article-footer">
            <div class="article-tags"></div>
            <!--
                        <div class="article-share">
                            <ul class="social">
                                <li><span>Share:</span></li>
                                <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>
                        -->
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12">
        <aside class="widget-area" id="secondary">
          <section class="widget widget_recent_entries">
            <h2 class="widget-title">احدث منشورات</h2>

            <ul>
              <li *ngFor="let article of latestArticles">
                <a
                  [routerLink]="['/article']"
                  [queryParams]="{ title: article?.title, id: article?.id }"
                >
                  {{ article.title }}
                </a>
              </li>
            </ul>
          </section>
          <!-- Affichage de la note moyenne -->
          <!-- Average Rating Display -->
          <!-- Average Rating Display -->
        </aside>
      </div>
    </div>
  </div>
</section>
